import { createApp } from 'petite-vue';

createApp({
    // data
    toggled : false,
    c_ga : false,
    c_cd : false,
    c_fm : false,
    timestamp : false,
    canStorage : false,
    storage : null,
    debug : false,
    buttonHide : false,


    // computed
    get isToggled()
    {
        const overlay = document.getElementById("gdpr__overlay");
        const btn     = document.getElementById("gdpr__btn");

        if (this.toggled) {
            if (overlay) {
                overlay.classList.add("gdpr__overlay--active");
            }
            if (btn) {
                btn.classList.add("gdpr__btn--hidden");
            }
        } else {
            if (overlay) {
                overlay.classList.remove("gdpr__overlay--active");
            }
            if (btn) {
                btn.classList.remove("gdpr__btn--hidden");
            }
        }

        return (this.toggled) ? ' active ' : '';
    },

    get isButtonHide()
    {
        return (this.buttonHide) ? ' btnHide ' : '';
    },


    // methods
    toggleOptions()
    {
        this.toggled = (this.toggled) ? false : true;
        document.querySelector("body").classList.toggle("gdprBlur");

        if (!this.toggled) {
            this.storeSettings(this.storage);
        }
    },

    toggleSettings() {
        document.getElementById("gdpr__settings").classList.toggle("gdpr__settings--active");
        document.getElementById("gdpr__text-container").classList.toggle("gdpr__text-container--active");
    },

    hideSettings() {
        document.getElementById("gdpr__settings").classList.remove("gdpr__settings--active");
        document.getElementById("gdpr__text-container").classList.remove("gdpr__text-container--active");
    },

    updateSettings(key)
    {
        if (key === "c_ga" || key === "c_cd" || key === "c_fm" ) {
            this[key] = (this[key]) ? false : true;
            this.storage[key] = this[key];
            this.storeSettings(this.storage);
            localStorage.getItem("tibe_gdpr");
            this.buttonHide = false;
        } else if (key === "all") {
            this.acceptCookies();
            this.toggleOptions();
            this.buttonHide = true;
            this.hideSettings();
        } else if (key === "none") {
            this.declineCookies();
            this.toggleOptions();
            this.buttonHide = false;
            this.hideSettings();
        } else if (key === "selected") {
            this.toggleOptions();
            this.hideSettings();
        }
        
        if (this.storage.c_ga == false && this.storage.c_cd == false) {
            this.removeScript();
        }
        
        this.outputScript();
        this.pushToDataLayer();
    },

    acceptCookies()
    {
        this.c_cd = this.c_ga = this.c_fm = true;
        this.storage.c_ga = this.c_ga;
        this.storage.c_cd = this.c_cd;
        this.storage.c_fm = this.c_fm;
        this.storeSettings(this.storage);
    },

    declineCookies()
    {
        this.c_cd = this.c_ga = this.c_fm = false;
        this.storage.c_ga = this.c_ga;
        this.storage.c_cd = this.c_cd;
        this.storage.c_fm = this.c_fm;
        this.removeScript();
        this.storeSettings(this.storage);
    },

    storeSettings(settings)
    {
        const gdpr = JSON.stringify(settings);
        localStorage.setItem("tibe_gdpr", gdpr);
    },

    initStorge()
    {
        if (this.canStorage) {
            const storage = localStorage.getItem("tibe_gdpr");

            const now = Date.now();
            const latestUpdate = new Date('2021-10-05 10:15:00').getTime();
            if (!storage) {
                this.storage = {
                   c_ga : this.c_ga,
                   c_cd : this.c_cd,
                   c_fm : this.c_fm,
                   timestamp : now,
                };
                this.toggleOptions();
            } else {
                this.storage = JSON.parse(storage);
                this.c_ga = this.storage.c_ga;
                this.c_cd = this.storage.c_cd;
                this.c_fm = this.storage.c_fm;
                this.timestamp = this.storage.timestamp;
                if (!this.timestamp || this.timestamp < latestUpdate) {
                    this.storage.timestamp = now;
                    this.toggleOptions();
                }
            }

            this.pushToDataLayer();
        }
    },

    pushToDataLayer()
    {
        this.constentMode(this.c_ga ? true : false);

        if (this.c_ga) {
            this.fireEvents('c_ga');
        }

        if (this.c_cd) {
            this.fireEvents('c_cd');
        }
    },

    constentMode(constentGiven=false)
    {
        const permission = constentGiven ? 'granted' : 'denied';

        if (this.debug) {
            console.log('constentMode: '+permission);
        }

        const args = {
            'ad_storage': permission,
            'ad_personalization': permission,
            'ad_user_data': permission,
            'analytics_storage': permission,
            'personalization_storage': permission,
            'functionality_storage': permission,
            'security_storage': permission,
        };

        this.gtag('consent', 'default', args);
    },

    fireEvents(type)
    {
        if (this.debug) {
            console.info("");
            console.info('fireEvents: '+type);
            // console.log(tbcEvents);
        }

        let pushEvent = '';
        for (let i=0; i<tbcEvents[type].length; i++) {
            // https://mlocati.github.io/articles/gdpr-google-tag-manager.html
            pushEvent = {"event": tbcEvents[type][i] };
            this.gtag(pushEvent);

            if (this.debug) {
                console.log('TRIGGER event');
                console.log(pushEvent);
            }
        }
    },

    gtag()
    {
        if (this.debug) {
            console.log('gtag');
            console.log(arguments);
        }

        window.dataLayer = window.dataLayer || [];

        dataLayer.push(arguments);
    },

    outputScript()
    {
        if (this.debug) {
            console.info("Output script");
        }

        if (!this.c_ga && !this.c_cd) {
            return false;
        }

        const tbcGtmId = document.querySelector('[data-tbcGtmId]');
        let tbcGtmIdValue = '';
        if (tbcGtmId) {
            tbcGtmIdValue = tbcGtmId.value;
        }

        const gtm = document.querySelector('[data-gtm]');
        if (gtm && tbcGtmIdValue!='') {
            gtm.innerHTML = `
            (function(w,d,s,l,i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event      :'gtm.js'
                });
                var f  = d.getElementsByTagName(s)[0],
                    j  = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';

                j.async = true;
                j.src   = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', '` + tbcGtmIdValue + `');`
        }
        else if (this.debug) {
            console.log("[data-gtm not found]");
        }

        const gtmExtra      = document.querySelector('[data-gtm-extra]');
        const gtmExtraValue = gtmExtra ? gtmExtra.getAttribute('data-gtm-extra') : null;
        if (gtmExtra && gtmExtraValue) {
            gtmExtra.innerHTML = `
            (function(w,d,s,l,i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event      :'gtm.js'
                });
                var f  = d.getElementsByTagName(s)[0],
                    j  = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';

                j.async = true;
                j.src   = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', '` + gtmExtraValue + `');`
        }
        else if (this.debug) {
            console.log("[data-gtm-extra not found]");
        }


        const matomo = document.querySelector('[data-matomo-tellus]');
        if (matomo) {
            var _paq = window._paq;
            if (_paq) {
                // user has given consent to process their data
                _paq.push(['setConsentGiven']);

                // OR user has given consent to store and use cookies
                _paq.push(['setCookieConsentGiven']);
            }
        }
        else if (this.debug) {
            console.log("[data-matomo-tellus not found]");
        }

        const adwords = document.querySelector('[data-adwords]');
        const adwordsValue = adwords ? adwords.getAttribute('data-adwords') : null;
        if (adwords && adwordsValue) {
            adwords.src = "https://www.googletagmanager.com/gtag/js?id=" + adwordsValue;
        }

        const adwordsData = document.querySelector('[data-adwords-data]');
        const adwordsDataValue = adwordsData ? adwordsData.getAttribute('data-adwords-data') : null;
        if (adwordsData && adwordsDataValue) {
            adwordsData.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', '${adwordsDataValue}');
            `;
        }
    },

    removeScript()
    {
        if (this.debug) {
            console.info("Output script");
        }

        const gtm = document.querySelector('[data-gtm]');
        if (gtm) {
            gtm.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-gtm not found]");
        }

        const gtmExtra = document.querySelector('[data-gtm-extra]');
        if (gtmExtra) {
            gtmExtra.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-gtm-extra not found]");
        }

        const matomo = document.querySelector('[data-matomo-tellus]');
        if (matomo) {
            matomo.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-matomo-tellus not found]");
        }

        const matomoBody = document.querySelector('[data-matomo-tellus-body]');
        if (matomoBody) {
            matomoBody.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-matomo-tellus-body not found]");
        }

        const matomoTag = document.querySelector('[data-matomo-tellus-tag]');
        if (matomoTag) {
            var _paq = window._paq;
            if (_paq) {
                // revoke tracking consent
                _paq.push(['forgetConsentGiven']);
    
                // OR revoke cookie consent
                _paq.push(['forgetCookieConsentGiven']);
            }
        }
        else if (this.debug) {
            console.log("[data-matomo-tellus-tag not found]");
        }

        const matomoTagBody = document.querySelector('[data-matomo-tellus-tag-body]');
        if (matomoTagBody) {
            matomoTagBody.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-matomo-tellus-tag-body not found]");
        }

        const adwords = document.querySelector('[data-adwords]');
        if (adwords) {
            adwords.innerHTML = "";
        }
        else if (this.debug) {
            console.log("[data-adwords not found]");
        }
    },

    fixAutocomplete()
    {
        if (!this.c_fm) {
            const formsCollection = document.getElementsByTagName("form");
            for (let i=0;i<formsCollection.length;i++) {
                formsCollection[i].autocomplete = 'off';
            }

            const inputCollection = document.getElementsByTagName("input");
            for (let i=0;i<inputCollection.length;i++) {
                inputCollection[i].autocomplete = 'off';
            }
        }
    },

    enableDebugModus()
    {
        const queryString = window.location.search;
        if (queryString.search('debug=gdpr') != -1) {
            console.log("enable debug modus…");
            this.debug = true;
        }

        if (this.debug) {
            console.log('active events');
            console.log(tbcEvents);
        }
    },

    created ()
    {
        this.enableDebugModus();

        this.canStorage = (typeof(Storage) !== "undefined");
        if (this.canStorage) {
            this.initStorge();
            this.outputScript();
            this.fixAutocomplete();
        }
    }
}).mount('#a9f642be9c8f5ccd5ab42f157ae18c5f');
